<template>
	<div class="page-container">
		<head-top head-title="上报记录" goBack="true"></head-top>

		<div class="record-page">
			<van-pull-refresh v-model="refreshing" @refresh="onRefresh">
				<van-empty v-if="!loading && finished && records.length === 0" description="暂无记录" />
				<van-list :offset="40" v-else v-model="loading" :finished="finished" :immediate-check="false"
					:finished-text="finished ? '没有更多了~' : ''" @load="onLoad">
					<div class="record-list">
						<div class="record-group bg_a" v-for="product in records" :key="product.id">
							<div class="record-time">上报时间：{{ product.createTime }}</div>
							<div class="record-item flex_c">
								<div class="record-logo">
									<img v-if="product.logo" :src="getImageUrl(product.logo)" />
								</div>
								<div class="record-info">
									<div class="product-row product-link">
										{{ product.submissionLink || '-' }}
									</div>
									<div class="product-row product-remark">
										备注：{{ product.remark || '-'}}
									</div>
									<div class="product-row flex_c">
										<div>
											<span class="color_e">折后单价：</span>
											<span class="color_d">${{ product.price || '0.00' }}</span>
										</div>
										<div>
											<span class="color_e">数量：</span>
											<span class="color_d">{{ product.totalNum || 0 }}</span>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</van-list>
			</van-pull-refresh>
		</div>

		<div class="back-to-top" :class="{ show: showBackToTop }" @click="scrollToTop">
			<van-icon name="back-top" />
		</div>
	</div>
</template>

<script>
	import headTop from '@/components/common/head.vue'

	import {
		getLoginMember,
		getSubmissionList,
		imageUrl
	} from '@/apis/api.js'

	export default {
		name: 'SubmissionRecords',
		components: {
			headTop
		},
		data() {
			return {
				records: [],
				pageNum: 0,
				pageSize:10,
				loading: false,
				finished: false,
				refreshing: false,
				showBackToTop: false
			}
		},
		mounted() {
			if (!getLoginMember()) {
				this.$router.push('/login?redirect=' + encodeURIComponent(this.$route.fullPath))
				return
			}
			this.getList()
			window.addEventListener('scroll', this.handleScroll)
		},
		beforeDestroy() {
			window.removeEventListener('scroll', this.handleScroll)
		},
		methods: {
			getImageUrl(path) {
				return imageUrl(path)
			},
			getList() {
				this.pageNum++
				getSubmissionList({
						pageNum: this.pageNum,
						pageSize: this.pageSize
					})
					.then(res => {
						const rows = res.rows || []
						this.total = res.total || 0
						this.records = this.records.concat(rows)
						if (this.records.length >= this.total) {
							this.finished = true
						} else {
							this.finished = false
						}
					})
					.catch(e => {
						this.finished = true
						if (!e.handled) {
							this.$toast('加载失败')
						}
					})
					.finally(() => {
						this.loading = false
						this.refreshing = false
					})
			},
			onRefresh() {
				this.pageNum = 0
				this.records = []
				this.finished = false
				this.getList()
			},
			onLoad() {
				if (this.refreshing || this.finished) return
				this.getList()
			},
			handleScroll() {
				const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
				this.showBackToTop = scrollTop > 300
			},
			scrollToTop() {
				window.scrollTo({
					top: 0,
					behavior: 'smooth'
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.page-container {
		padding-top: 48px;

		.record-page {
			.record-list {
				padding:14px 0px;

				.record-group {
					margin-bottom: 14px;

					.record-time {
						border-bottom:1px solid #e4e7ed;
						height:38px;
						line-height: 38px;
						font-size: 14px;
						color: #666;
						padding:0 14px;
					}

					.record-item {
						padding: 14px;

						.record-logo {
							flex: none;
							width: 50px;
							height: 50px;
							margin-right: 12px;
							background: #fff;
							border-radius: 4px;
							overflow: hidden;

							img {
								width: 100%;
								height: 100%;
								object-fit: contain;
							}
						}

						.record-info {
							flex: 1;

							.product-row {
								width:100%;
								font-size: 13px;
							}
							.product-link{
								margin-bottom:5px;
								color: #333;
								word-break: break-all;
							}
							.product-remark{
								margin-bottom: 5px;
								color: #999;
								font-size:13px;
								word-break: break-all;
							}
						}
					}
				}

				.empty-state {
					padding-top: 60px;
				}
			}
		}

		.back-to-top {
			position: fixed;
			right: 20px;
			bottom: 90px;
			width: 44px;
			height: 44px;
			background: #ffffff;
			border-radius: 50%;
			box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
			display: flex;
			align-items: center;
			justify-content: center;
			opacity: 0;
			visibility: hidden;
			transition: all 0.3s ease;
			z-index: 1000;

			&.show {
				opacity: 1;
				visibility: visible;
			}

			.van-icon {
				font-size: 24px;
				color: #444;
			}
		}
	}
</style>